import Spinner from '@rio-cloud/rio-uikit/Spinner';

export const LoadingIndicator = () => (
    <div data-testid="loading-spinner" className="display-flex justify-content-center">
        <Spinner />
    </div>
);
